/* eslint-disable */
import HmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';
import axios from 'axios';
import { appInsights } from './appInsights';

interface CustomUserFields {
  [key: string]: string;
}

export interface GlobalUserData {
  first_name?: string;
  last_name?: string;
  full_name?: string;
  display_name?: string;
  last_country?: string;
  last_city?: string;
  age?: string;
  lifetime_value?: string;
  user_persona?: string;
  user_vip_segment?: string;
  user_support_status?: string;
  last_active_date?: string; // epoch time in ms/seconds
  accepted_t_and_c?: string; // true/false converted to string
  preferred_language?: string;

  // Non-primitives
  new_tags?: Array<string>;
  tags_to_remove?: Array<string>;
  reset_tags?: Array<string>;
  custom_user_fields?: CustomUserFields;
}

interface InitializeHelpshiftChatOptions {
  platformId: string;
  domain: string;
  language: string;
  userName: string;
  userEmail: string;
  userId: string;
  // steam_id: string;
  globalUserData: GlobalUserData;
  accessToken: string | null;
  property?: string;
  // userAuthToken?: string;
  userFirstMessage?: string;
  customIssueFields?: Record<string, { type: string; value: string }>;
}

export function hmac(uid: string | null, email: string | null, secret: string): string {
  let message = '';
  if (uid) message += uid;
  if (email) message += email;

  return Base64.stringify(HmacSHA256(message, secret));
}

const updateHelpshiftUserData = (userData: GlobalUserData) => {
  Object.entries(userData).forEach(([key, value]) => {
    if (value !== undefined) {
      const fieldName = key;
      const fieldValue = value;
      (window as any).Helpshift('updateGlobalUserData', { [fieldName]: fieldValue });
    }
  });
};

export function initializeHelpshiftChat({
  platformId,
  domain,
  language,
  userName,
  userEmail,
  userId,
  // steam_id,
  globalUserData,
  accessToken,
  property,
  // userAuthToken,
  userFirstMessage,
  customIssueFields,
}: InitializeHelpshiftChatOptions) {
  const test = {
    platformId,
    domain,
    language,
    userName,
    userEmail,
    userId,
    globalUserData,
    accessToken,
    property,
    // userAuthToken,
    userFirstMessage,
    customIssueFields,
    // steam_id,
    // log(settings?.configs.showLogs, 'initializeHelpshiftChat called with parameters:', test);
    // log(settings?.configs.showLogs, 'some data');
  };
  (window as any).helpshiftConfig = {
    platformId,
    domain,
    language,
    userName,
    userEmail,
    userId,
    // userAuthToken,
    authenticateWith: 'identities',
  };
  //eslint-disable-next-line
  // console.log('window.helpshiftConfig initialized:', (window as any).helpshiftConfig);
  // log('window.helpshiftConfig initialized:', (window as any).helpshiftConfig);
  if (typeof (window as any).Helpshift !== 'function') {
    const Helpshift = function () {
      (Helpshift as any).q.push(arguments);
    };
    (Helpshift as any).q = [];
    (window as any).Helpshift = Helpshift;

    const scriptId = 'hs-chat';
    if (!document.getElementById(scriptId)) {
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.id = scriptId;
      scriptElement.src = 'https://webchat.helpshift.com/latest/webChat.js';

      scriptElement.addEventListener('load', () => {
        (window as any).Helpshift('init');
        if (customIssueFields) {
          (window as any).Helpshift('setCustomIssueFields', customIssueFields);
        }

        switch (property) {
          case 'showWidget':
            (window as any).Helpshift('show');
            break;
          case 'hideWidget':
            (window as any).Helpshift('hide');
            break;
          case 'openWidget':
            (window as any).Helpshift('open');
            break;
          case 'closeWidget':
            (window as any).Helpshift('close');
            break;
          case 'showWidget,openWidget':
          case 'openWidget,showWidget':
            (window as any).Helpshift('show');
            (window as any).Helpshift('open');
            break;
          default:
            console.log('Invalid property value:', property);
            break;
        }
      });

      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript.parentNode) {
        firstScript.parentNode.insertBefore(scriptElement, firstScript);
      }
      if (userFirstMessage && window.helpshiftConfig) {
        window.helpshiftConfig.initialUserMessage = userFirstMessage;
        window.helpshiftConfig.initiateChatOnLoad = true;
        (window as any).Helpshift('updateHelpshiftConfig');
      }
    }
  } else {
    // Handle cases where Helpshift is already defined
    if (customIssueFields) {
      (window as any).Helpshift('setCustomIssueFields', customIssueFields);
    }
    switch (property) {
      case 'showWidget':
        (window as any).Helpshift('show');
        break;
      case 'hideWidget':
        (window as any).Helpshift('hide');
        break;
      case 'openWidget':
        (window as any).Helpshift('open');
        break;
      case 'closeWidget':
        (window as any).Helpshift('close');
        break;
      case 'showWidget,openWidget':
      case 'openWidget,showWidget':
        (window as any).Helpshift('show');
        (window as any).Helpshift('open');
        break;
      default:
        console.log('Invalid property value:', property);
        // log('Invalid property value:', );
        break;
    }
    if (userFirstMessage && window.helpshiftConfig) {
      window.helpshiftConfig.initialUserMessage = userFirstMessage;
      window.helpshiftConfig.initiateChatOnLoad = true;
      (window as any).Helpshift('updateHelpshiftConfig');
    }
  }
  (window as any).accessToken = accessToken;
  // const steamId = steam_id;
  (window as any).Helpshift(
    'addEventListener',
    'onLoginRequest',
    async ({ userId, userEmail }: { userId: string; userEmail?: string }) => {
      try {
        var accessToken = (window as any).accessToken;
        console.log('accessToken', accessToken);
        // let url = `https://catalysthc.ms.helpshift.live/api/user-identity-token`;
        let url = `https://demo-hc-api.ms.helpshift.live/api/user-identity-token`;
        const params = new URLSearchParams();
        if (userId?.trim()) {
          params.append('uid', userId);
        }
        if (userEmail?.trim()) {
          params.append('email', userEmail);
        }
        // if (steamId?.trim()) {
        //   params.append('steam_id', steamId);
        // }
        if (params.toString()) {
          url += `?${params.toString()}`;
        }

        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: url,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };
        const response = await axios.request(config);
        const identityToken = await response.data.token;
        (window as any).Helpshift('login', {
          identity_token: identityToken,
          full_privacy_enabled: false,
        });
      } catch (error) {
        appInsights.trackEvent({
          name: 'APIFailure',
          properties: {
            apiName: 'user-identity-token',
            userName: userName,
            userId: userId,
            userEmail: userEmail,
            // steamId: steamId,
            errorMessage: error instanceof Error ? error.message : 'Unknown error',
            timestamp: Date.now(),
          },
        });
        console.error('Error during Helpshift login:', error);
      }
    },
  );
  (window as any).helpshiftConfig.userName = userName;
  // (window as any).helpshiftConfig.userId = userId;
  (window as any).helpshiftConfig.userEmail = userEmail;

  (window as any).Helpshift('updateHelpshiftConfig');
  updateHelpshiftUserData(globalUserData);
}

export function listenToConversationStatus(): Promise<{
  open: boolean;
  latestIssueId: string;
  latestIssuePublishId: string;
}> {
  return new Promise(resolve => {
    const handler = function (data: {
      open: boolean;
      latestIssueId: string;
      latestIssuePublishId: string;
    }) {
      resolve(data);

      //  Remove listener after data is received
      if ((window as any).Helpshift) {
        (window as any).Helpshift('removeEventListener', 'conversationStatus', handler);
      }
    };

    if ((window as any).Helpshift) {
      (window as any).Helpshift('addEventListener', 'conversationStatus', handler);
    } else {
      console.warn('Helpshift is not initialized yet.');
      resolve({
        open: false,
        latestIssueId: 'NOT_AVAILABLE',
        latestIssuePublishId: 'NOT_AVAILABLE',
      });
    }
  });
}

// Function to update globalConfig timestamp
export type GlobalConfig = {
  [key: string]: string;
};

export function updateConfigVersion(globalConfig?: GlobalConfig): GlobalConfig {
  const updatedConfig = { ...globalConfig };

  if (updatedConfig.config) {
    const timestamp = Date.now(); // You can use new Date().getTime() as well

    // Remove any existing version query param (?v=...)
    const baseUrl = updatedConfig.config.replace(/(\?v=)[^&]+/, '');

    // Append the new timestamp version
    updatedConfig.config = `${baseUrl}?v=${timestamp}`;
  }

  return updatedConfig;
}
export function log(showLogs?: boolean, ...args: any[]) {
  if (showLogs) {
    console.log(...args);
  }
}

export const generateSlug = (title: string) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // remove special characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // collapse multiple hyphens
};
